import { connectEditor } from './connect-editor';
import QuoteLineTableSum from './QuoteLineTable/QuoteLineTableSum';
import { calculateSums } from './utils/calculate-derived-values';

export default connectEditor(({ quoteLinesById, quote }) =>
  calculateSums(
    quote.quoteLines.map(id => quoteLinesById[id]),
    quote.headerDiscountPercent,
  ),
)(QuoteLineTableSum);
